import AccountService from "@/common/account.service";
import { FETCH_INDUSTRY_MATCHED_USER } from "./actions.type";
import {
    FETCH_START_INDUSTRY_MATCHED_USER,
    FETCH_END_INDUSTRY_MATCHED_USER,
    SET_INDUSTRY_MATCHED_USER
} from "./mutations.type";

const state = {
    matchedUsersByIndustryCode: {},
    isLoading: false
};

const getters = {
    // Returns array of matched users for a given industry code
    getIndustryMatchedUsers: (state) => (industryCode) => {
        if (!industryCode) return [];
        return state.matchedUsersByIndustryCode[String(industryCode)] || [];
    },
    isLoadingIndustryMatchedUser(state) {
        return state.isLoading;
    }
};

const actions = {
    [FETCH_INDUSTRY_MATCHED_USER]({ state, commit }, payload) {
        const industryCode = payload && payload.industryCode;
        const force = payload && payload.force;
        if (!industryCode) return Promise.resolve([]);

        const key = String(industryCode);
        if (!force && state.matchedUsersByIndustryCode[key] !== undefined) {
            return Promise.resolve(state.matchedUsersByIndustryCode[key]);
        }

        commit(FETCH_START_INDUSTRY_MATCHED_USER);
        return AccountService.getMatchedUsersByIndustryCode(industryCode)
            .then((users) => {
                commit(SET_INDUSTRY_MATCHED_USER, { industryCode, users });
                commit(FETCH_END_INDUSTRY_MATCHED_USER);
                return users;
            })
            .catch((error) => {
                console.error("Error fetching industry matched users:", error);
                commit(SET_INDUSTRY_MATCHED_USER, { industryCode, users: [] });
                commit(FETCH_END_INDUSTRY_MATCHED_USER);
                return [];
            });
    }
};

const mutations = {
    [FETCH_START_INDUSTRY_MATCHED_USER](state) {
        state.isLoading = true;
    },
    [FETCH_END_INDUSTRY_MATCHED_USER](state) {
        state.isLoading = false;
    },
    [SET_INDUSTRY_MATCHED_USER](state, payload) {
        const key = String(payload.industryCode);
        state.matchedUsersByIndustryCode = {
            ...state.matchedUsersByIndustryCode,
            [key]: payload.users || []
        };
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
